import { Component, Vue } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/course';

@Component
export default class tableMixin extends Vue {
  private cList: any = [];

  public chapterId: string = '';

  private column: Array<ITABLECOLCONF> = [{
    label: '资源名称',
    prop: 'resourceTitle',
    align: 'center',
    width: '200px',
    tooltip: true,
  }, {
    label: '关联题目',
    prop: 'linkedQuestionLabel',
    custom: true,
    slotName: 'questionLink',
    align: 'left',
    width: '180px',
    tooltip: true,
  }, {
    label: '缩略图标',
    prop: 'resourceImage',
    align: 'center',
    custom: true,
    icon: true,
    showBigImg: true,
    width: '80px',
  }, {
    label: '文件',
    prop: 'resourcePath',
    align: 'center',
    width: '200px',
    custom: true,
    link: true,
  },
  {
    label: '类别',
    prop: 'resourceType',
    custom: true,
    align: 'center',
    width: '200px',
    tags: [{
      value: '1',
      type: 'primary',
      label: 'Scratch可编辑模式',
    }, {
      value: '2',
      type: 'primary',
      label: 'Scratch舞台模式',
    }, {
      value: '3',
      type: 'primary',
      label: '视频',
    }, {
      value: '4',
      type: 'primary',
      label: '小视频',
    }, {
      value: '5',
      type: 'primary',
      label: '教案',
    }, {
      value: '6',
      type: 'primary',
      label: '演示课件',
    }, {
      value: '7',
      type: 'primary',
      label: 'Python源码模式',
    }, {
      value: '8',
      type: 'primary',
      label: 'Python演示模式',
    }, {
      value: '9',
      type: 'primary',
      label: 'Microbit源码模式',
    }, {
      value: '10',
      type: 'primary',
      label: 'Microbit演示模式',
    }, {
      value: '11',
      type: 'primary',
      label: 'Scratch3可编辑模式',
    }, {
      value: '12',
      type: 'primary',
      label: 'Scratch3舞台模式',
    }, {
      value: '13',
      type: 'primary',
      label: 'ZIP',
    }, {
      value: '14',
      type: 'primary',
      label: 'C++源码模式',
    }, {
      value: '15',
      type: 'primary',
      label: 'C++演示模式',
    }, {
      value: '16',
      type: 'primary',
      label: 'HTML教学工具',
    }],
  },
  {
    label: '使用者',
    prop: 'resourceUser',
    align: 'center',
    custom: true,
    width: '150px',
    tags: [{
      value: '1',
      type: 'info',
      label: '学生/老师',
    }, {
      value: '2',
      type: 'info',
      label: '老师',
    }, { value: '3', type: 'info', label: '学生' }],
  }, {
    label: '排序',
    prop: 'resourceSeq',
    align: 'center',
    width: '60px',
  }, {
    label: '创建时间',
    prop: 'createTime',
    align: 'center',
    minWidth: '100px',
    tooltip: true,
  }, {
    label: '操作',
    custom: true,
    fixed: 'right',
    minWidth: '120',
    align: 'center',
    maxBtn: 1,
    btnList: [
      {
        title: '',
        name: '/course/chapter/resource/public',
        icon: 'edit',
        type: 'info',
        callback: this.handleOperate,
        handleTitle: (row: any) => {
          if (row.resourceType === 16) return '上传HTML包';
          if (row.resourceType === 3 || row.resourceType === 4 || row.resourceType === 5 || row.resourceType === 6 || row.resourceType === 13) return '上传文件';
          return '关联作品';
        },
        log: {
          name: '课程信息 - 操作',
          component: 'course/info/tableMixin',
        },
      },
      {
        title: '修改',
        name: '/course/chapter/resource:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleEdit,
        log: {
          name: '课程信息 - 修改',
          component: '/course/info:update',
        },
      },
      {
        title: '删除',
        name: '/course/chapter/resource:remove',
        icon: 'trash-o',
        type: 'info',
        callback: this.handleRemove,
        log: {
          name: '课程信息 - 删除',
          component: '/course/chapter/rescource:remvoe',
        },
      },
    ],
  }]

  private loading: boolean = false;

  /** 关联仅适用于C++源码类型14；其他资源显示不适用，不暗示缺失配置。 */
  questionLabel = (item: any): string => {
    if (item.resourceType !== 14) return '—';
    if (item.linkedQuestion) {
      return `${item.linkedQuestion.questionId} · ${item.linkedQuestion.title}`;
    }
    return item.ojQuestionPid ? '关联题目不可用，请重新选择或清除' : '未关联';
  };

  /** 获取章节资源并生成关联摘要；pid 为章节主键，返回加载 Promise。 */
  getData(pid: string) {
    return new Promise((resolve, reject) => {
      api.getCourse(pid).then((res: any) => {
        this.cList = res.map((item: any) => ({
          ...item,
          linkedQuestionLabel: this.questionLabel(item),
        }));
        this.chapterId = pid;
        resolve(res);
      });
    });
  }

  /* eslint-disable class-methods-use-this */
  handleEdit(row: any) {}

  handleOperate(row: any) {}

  /**
   * @author liangyongmou
   * @desc 删除正式课事件
   * @params { any } row 行数据
   */
  handleRemove(row: any) {
    this.confirm('你确定要删除该资源吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeRescource(row.pid).then(() => {
        this.getData(this.chapterId);
        close();
        this.$log({
          title: '正式课管理 - 课程资源删除 - 确定',
          component: 'course/chapter/rescource',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '正式课管理 - 课程资源删除 - 取消',
      component: 'course/chapter/rescource',
    }));
  }
}
